import { Component, Event, EventEmitter, h } from '@stencil/core';
import { ClickOutside } from "../../../utils/stencil/clickOutside";

@Component({
    tag: 'rentware-wrapper',
    styleUrl: 'style.sass',
    shadow: true,
})

export class RentwareWrapper {
    @Event() clickOutside: EventEmitter;

    @ClickOutside()
    someMethod({ target }) {
        this.clickOutside.emit({ target });
    }

    render() {
        return (
            <div>
                <slot />
            </div>
        );
    }
}
